export { default as ViewToggle } from './ViewToggle';